// TODO Check security
// export const ACCOUNT_RIGHT_EDIT_USER_RIGHTS = {
//   value: 'editUserRights',
//   label: 'Modifer des droits utilisateur'
// }

export const ACCOUNT_RIGHT_CREATE_AGENT = {
  value: 'createAgent',
  label: 'Créer un agent'
}
export const ACCOUNT_RIGHT_LIST_AVAILABLE_AGENTS = {
  value: 'listAvailableAgents',
  label: 'Lister les agents disponibles'
}
export const ACCOUNT_RIGHT_LIST_AGENTS = {
  value: 'listAgents',
  label: 'Lister les agents'
}
export const ACCOUNT_RIGHT_READ_AGENT = {
  value: 'readAgent',
  label: 'Afficher un agent',
  dependencies: [ACCOUNT_RIGHT_LIST_AGENTS]
}
export const ACCOUNT_RIGHT_EDIT_AGENT = {
  value: 'editAgent',
  label: 'Modifier un agent',
  dependencies: [ACCOUNT_RIGHT_READ_AGENT]
}
export const ACCOUNT_RIGHT_DELETE_AGENT = {
  value: 'deleteAgent',
  label: 'Supprimer un agent',
  dependencies: [ACCOUNT_RIGHT_LIST_AGENTS]
}

export const ACCOUNT_RIGHT_CREATE_CUSTOMER = {
  value: 'createCustomer',
  label: 'Créer un client'
}
export const ACCOUNT_RIGHT_LIST_CUSTOMERS = {
  value: 'listCustomers',
  label: 'Lister les clients'
}
export const ACCOUNT_RIGHT_READ_CUSTOMER = {
  value: 'readCustomer',
  label: 'Afficher un client',
  dependencies: [ACCOUNT_RIGHT_LIST_CUSTOMERS]
}
export const ACCOUNT_RIGHT_EDIT_CUSTOMER = {
  value: 'editCustomer',
  label: 'Modifer un client',
  dependencies: [ACCOUNT_RIGHT_READ_CUSTOMER]
}
export const ACCOUNT_RIGHT_DELETE_CUSTOMER = {
  value: 'deleteCustomer',
  label: 'Supprimer un client',
  dependencies: [ACCOUNT_RIGHT_LIST_CUSTOMERS]
}

export const ACCOUNT_RIGHT_CREATE_SITE = {
  value: 'createSite',
  label: 'Créer un site',
  dependencies: [ACCOUNT_RIGHT_LIST_CUSTOMERS]
}

export const ACCOUNT_RIGHT_LIST_SITES = {
  value: 'listSites',
  label: 'Lister les sites'
}

// export const ACCOUNT_RIGHT_LIST_ALL_SITES = {
//   value: 'listAllSites',
//   label: 'Lister tous les sites',
//   dependencies: [ACCOUNT_RIGHT_LIST_SITES]
// }
export const ACCOUNT_RIGHT_READ_SITE = {
  value: 'readSite',
  label: 'Afficher un site',
  dependencies: [ACCOUNT_RIGHT_LIST_SITES]
}
export const ACCOUNT_RIGHT_EDIT_SITE = {
  value: 'editSite',
  label: 'Modifer un site',
  dependencies: [ACCOUNT_RIGHT_READ_SITE, ACCOUNT_RIGHT_LIST_CUSTOMERS]
}
export const ACCOUNT_RIGHT_DELETE_SITE = {
  value: 'deleteSite',
  label: 'Supprimer un site',
  dependencies: [ACCOUNT_RIGHT_LIST_SITES]
}

export const ACCOUNT_RIGHT_LIST_SITE_ITEMS = {
  value: 'listSiteItems',
  label: `Lister le matériel d'un site`,
  dependencies: [ACCOUNT_RIGHT_EDIT_SITE]
}

export const ACCOUNT_RIGHT_EDIT_SITE_ITEMS = {
  value: 'editSiteItems',
  label: `Modifier le matériel d'un site`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_SITE_ITEMS
  ]
}

export const ACCOUNT_RIGHT_CREATE_CHECKPOINT = {
  value: 'createCheckpoint',
  label: 'Créer un point de contrôle',
  dependencies: [ACCOUNT_RIGHT_LIST_CUSTOMERS, ACCOUNT_RIGHT_LIST_SITES]
}
export const ACCOUNT_RIGHT_LIST_CHECKPOINTS = {
  value: 'listCheckpoints',
  label: 'Lister les points de contrôle'
}
export const ACCOUNT_RIGHT_READ_CHECKPOINT = {
  value: 'readCheckpoint',
  label: 'Afficher un point de contrôle',
  dependencies: [ACCOUNT_RIGHT_LIST_CHECKPOINTS]
}
export const ACCOUNT_RIGHT_EDIT_CHECKPOINT = {
  value: 'editCheckpoint',
  label: 'Modifer un point de contrôle',
  dependencies: [ACCOUNT_RIGHT_LIST_CHECKPOINTS, ACCOUNT_RIGHT_LIST_CUSTOMERS, ACCOUNT_RIGHT_LIST_SITES]
}
export const ACCOUNT_RIGHT_DELETE_CHECKPOINT = {
  value: 'deleteCheckpoint',
  label: 'Supprimer un point de contrôle',
  dependencies: [ACCOUNT_RIGHT_LIST_CHECKPOINTS]
}
// export const ACCOUNT_RIGHT_LIST_ALL_CHECKPOINTS = {
//   value: 'listAllCheckpoints',
//   label: 'Lister tous les points de contrôle'
// }

export const ACCOUNT_RIGHT_CREATE_ROUND = {
  value: 'createRound',
  label: 'Créer une ronde',
  dependencies: [ACCOUNT_RIGHT_LIST_CUSTOMERS, ACCOUNT_RIGHT_LIST_SITES, ACCOUNT_RIGHT_LIST_CHECKPOINTS]
}
export const ACCOUNT_RIGHT_LIST_ROUNDS = {
  value: 'listRounds',
  label: 'Lister les rondes'
}
export const ACCOUNT_RIGHT_LIST_MISSIONS_ROUNDS = {
  value: 'listMissionRounds',
  label: 'Lister les rondes du site'
}
// export const ACCOUNT_RIGHT_LIST_ALL_ROUNDS = {
//   value: 'listAllRounds',
//   label: 'Lister toutes les rondes'
// }
export const ACCOUNT_RIGHT_READ_ROUND = {
  value: 'readRound',
  label: 'Afficher une ronde',
  dependencies: [ACCOUNT_RIGHT_LIST_ROUNDS]
}
export const ACCOUNT_RIGHT_EDIT_ROUND = {
  value: 'editRound',
  label: 'Modifer une ronde',
  dependencies: [ACCOUNT_RIGHT_READ_ROUND, ACCOUNT_RIGHT_LIST_CUSTOMERS, ACCOUNT_RIGHT_LIST_SITES, ACCOUNT_RIGHT_LIST_CHECKPOINTS]
}
export const ACCOUNT_RIGHT_DELETE_ROUND = {
  value: 'deleteRound',
  label: 'Supprimer une ronde',
  dependencies: [ACCOUNT_RIGHT_LIST_ROUNDS]
}

export const ACCOUNT_RIGHT_CREATE_MISSION = {
  value: 'createMission',
  label: 'Créer un service',
  dependencies: [ACCOUNT_RIGHT_LIST_SITES]
}
export const ACCOUNT_RIGHT_LIST_MISSIONS = {
  value: 'listMissions',
  label: 'Lister les services'
}
export const ACCOUNT_RIGHT_READ_MISSION = {
  value: 'readMission',
  label: 'Afficher un service',
  dependencies: [ACCOUNT_RIGHT_LIST_MISSIONS]
}
export const ACCOUNT_RIGHT_EDIT_MISSION = {
  value: 'editMission',
  label: 'Modifer un service',
  dependencies: [ACCOUNT_RIGHT_READ_MISSION, ACCOUNT_RIGHT_LIST_SITES]
}
export const ACCOUNT_RIGHT_DELETE_MISSION = {
  value: 'deleteMission',
  label: 'Supprimer un service',
  dependencies: [ACCOUNT_RIGHT_LIST_MISSIONS, ACCOUNT_RIGHT_EDIT_MISSION]
}
// export const ACCOUNT_RIGHT_LIST_ALL_MISSIONS = {
//   value: 'listAllMissions',
//   label: 'Lister toutes les services'
// }
// export const ACCOUNT_RIGHT_CREATE_MISSION_REQUEST = {
//   value: 'createMissionRequest',
//   label: 'Créer une demande de service'
// }
// export const ACCOUNT_RIGHT_LIST_MISSION_REQUESTS = {
//   value: 'listMissionRequests',
//   label: 'Lister les demandes de service'
// }

// export const ACCOUNT_RIGHT_LIST_REPORTS = {
//   value: 'listReports',
//   label: 'Liste les rapports'
// }
// export const ACCOUNT_RIGHT_READ_REPORT = {
//   value: 'readReport',
//   label: 'Afficher un rapport',
//   dependencies: [ACCOUNT_RIGHT_LIST_REPORTS]
// }
// export const ACCOUNT_RIGHT_EDIT_REPORT = {
//   value: 'editReport',
//   label: 'Modifer un rapport',
//   dependencies: [ACCOUNT_RIGHT_READ_REPORT]
// }
// export const ACCOUNT_RIGHT_HIDE_REPORT_EVENT = {
//   value: 'hideReportEvent',
//   label: `Masquer un évènement d'un rapport`
// }

export const ACCOUNT_RIGHT_CREATE_MISSION_EVENT = {
  value: 'createMissionEvent',
  label: 'Créer une main courante'
}
export const ACCOUNT_RIGHT_LIST_MISSION_EVENTS = {
  value: 'listMissionEvents',
  label: 'Lister les mains courantes'
}
export const ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS = {
  value: 'listSiteMissionEvents',
  label: `Lister les mains courantes d'un site`
}
export const ACCOUNT_RIGHT_READ_SITE_MISSION_EVENTS = {
  value: 'readSiteMissionEvents',
  label: `Lire les mains courantes d'un site`,
  dependencies: [ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS]
}
export const ACCOUNT_RIGHT_EDIT_MISSION_EVENT = {
  value: 'editMissionEvent',
  label: 'Modifer une main courante',
  dependencies: [ACCOUNT_RIGHT_LIST_MISSION_EVENTS]
}
export const ACCOUNT_RIGHT_DELETE_MISSION_EVENT = {
  value: 'deleteMissionEvent',
  label: 'Supprimer une main courante',
  dependencies: [ACCOUNT_RIGHT_LIST_MISSION_EVENTS]
}

export const ACCOUNT_RIGHT_CREATE_ESTIMATE = {
  value: 'createEstimate',
  label: 'Créer un devis'
}
export const ACCOUNT_RIGHT_LIST_ESTIMATES = {
  value: 'listEstimates',
  label: 'Lister les devis'
}
export const ACCOUNT_RIGHT_READ_ESTIMATE = {
  value: 'readEstimate',
  label: 'Afficher un devis',
  dependencies: [ACCOUNT_RIGHT_LIST_ESTIMATES]
}
export const ACCOUNT_RIGHT_EDIT_ESTIMATE = {
  value: 'editEstimate',
  label: 'Modifier un devis',
  dependencies: [ACCOUNT_RIGHT_READ_ESTIMATE]
}
export const ACCOUNT_RIGHT_SEND_ESTIMATE = {
  value: 'sendEstimate',
  label: 'Envoyer un devis',
  dependencies: [ACCOUNT_RIGHT_LIST_ESTIMATES]
}
export const ACCOUNT_RIGHT_DELETE_ESTIMATE = {
  value: 'deleteEstimate',
  label: 'Supprimer un devis',
  dependencies: [ACCOUNT_RIGHT_LIST_ESTIMATES]
}

export const ACCOUNT_RIGHT_CREATE_INVOICE = {
  value: 'createInvoice',
  label: 'Créer une facture'
}
export const ACCOUNT_RIGHT_LIST_INVOICES = {
  value: 'listInvoices',
  label: 'Lister les factures'
}
export const ACCOUNT_RIGHT_READ_INVOICE = {
  value: 'readInvoice',
  label: 'Afficher une facture',
  dependencies: [ACCOUNT_RIGHT_LIST_INVOICES]
}
export const ACCOUNT_RIGHT_EDIT_INVOICE = {
  value: 'editInvoice',
  label: 'Modifier une facture',
  dependencies: [ACCOUNT_RIGHT_READ_INVOICE]
}
export const ACCOUNT_RIGHT_SEND_INVOICE = {
  value: 'sendInvoice',
  label: 'Envoyer une facture',
  dependencies: [ACCOUNT_RIGHT_LIST_INVOICES]
}
export const ACCOUNT_RIGHT_DELETE_INVOICE = {
  value: 'deleteInvoice',
  label: 'Supprimer une facture',
  dependencies: [ACCOUNT_RIGHT_LIST_INVOICES]
}
//
// export const ACCOUNT_RIGHT_SUBSCRIBE = {
//   value: 'subscribe',
//   label: `S'abonner`
// }
// export const ACCOUNT_RIGHT_UNSUBSCRIBE = {
//   value: 'unsubscribe',
//   label: 'Se désabonner'
// }
//
// export const ACCOUNT_RIGHT_ADD_CREDIT_CARD = {
//   value: 'addCreditCard',
//   label: 'Ajouter une carte bancaire'
// }
// export const ACCOUNT_RIGHT_DELETE_CREDIT_CARD = {
//   value: 'deleteCreditCard',
//   label: 'Supprimer une carte bancaire'
// }
// export const ACCOUNT_RIGHT_LIST_CREDIT_CARDS = {
//   value: 'listCreditCards',
//   label: 'Lister les cartes bancaires'
// }
//
// export const ACCOUNT_RIGHT_LIST_SUBSCRIPTIONS = {
//   value: 'listSubscriptions',
//   label: 'Lister les abonnements'
// }
// export const ACCOUNT_RIGHT_LIST_SUBSCRIPTION_INVOICES = {
//   value: 'listSubscriptionInvoices',
//   label: 'Lister les factures des abonnements'
// }
//
// export const ACCOUNT_RIGHT_MANAGE_CONVERSATIONS = {
//   value: 'manageConversations',
//   label: 'Gestion des conversations'
// }

// export const ACCOUNT_RIGHT_READ_AGENCY_PLANNING = {
//   value: 'readAgencyPlanning',
//   label: `Afficher le planning de l'agence`,
//   dependencies: [ACCOUNT_RIGHT_LIST_MISSIONS]
// }
export const ACCOUNT_RIGHT_READ_AGENTS_PLANNING = {
  value: 'readAgentsPlanning',
  label: 'Accès au planning des agents',
  dependencies: [
    ACCOUNT_RIGHT_LIST_MISSIONS,
    ACCOUNT_RIGHT_LIST_CUSTOMERS,
    ACCOUNT_RIGHT_LIST_SITES,
    ACCOUNT_RIGHT_LIST_AGENTS
  ]
}
// export const ACCOUNT_RIGHT_READ_CUSTOMERS_PLANNING = {
//   value: 'readCustomersPlanning',
//   label: 'Afficher le planning des clients',
//   dependencies: [ACCOUNT_RIGHT_LIST_MISSIONS]
// }
export const ACCOUNT_RIGHT_READ_SITES_PLANNING = {
  value: 'readSitesPlanning',
  label: 'Accès au planning des sites',
  dependencies: [
    ACCOUNT_RIGHT_LIST_MISSIONS,
    ACCOUNT_RIGHT_LIST_CUSTOMERS,
    ACCOUNT_RIGHT_LIST_SITES,
    ACCOUNT_RIGHT_LIST_AGENTS
  ]
}
// export const ACCOUNT_RIGHT_READ_MISSIONS_PLANNING = {
//   value: 'readMissionsPlanning',
//   label: 'Afficher le planning des services'
// }

export const ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS = {
  value: 'editAgencyParameters',
  label: `Modifier les paramètres de l'agence`
}
// export const ACCOUNT_RIGHT_EDIT_PLANNING_PARAMETERS = {
//   value: 'editPlanningParameters',
//   label: 'Modifier les paramètres des exports de planning'
// }
// export const ACCOUNT_RIGHT_EDIT_EVENT_PARAMETERS = {
//   value: 'editEventParameters',
//   label: 'Modifier les paramètres des exports de main courantes'
// }
// export const ACCOUNT_RIGHT_EDIT_ESTIMATE_PARAMETERS = {
//   value: 'editEstimateParameters',
//   label: 'Modifier les paramètres de devis'
// }
// export const ACCOUNT_RIGHT_EDIT_INVOICE_PARAMETERS = {
//   value: 'editInvoiceParameters',
//   label: 'Modifier les paramètres de factures'
// }

// export const ACCOUNT_RIGHT_DISPLAY_IMPORT = {
//   value: 'displayImport',
//   label: `Afficher l'onglet d'import de données `
// }
// export const ACCOUNT_RIGHT_DISPLAY_STORE = {
//   value: 'displayStore',
//   label: 'Afficher la boutique'
// }
// export const ACCOUNT_RIGHT_DISPLAY_ASSISTANCE = {
//   value: 'displayAssistance',
//   label: `Afficher l'onglet d'assistance`
// }

export const ACCOUNT_RIGHT_CREATE_SELF_REQUEST = {
  value: 'createAgentSelfRequest',
  label: `Créer et consulter ses propres demandes`
}
export const ACCOUNT_RIGHT_CREATE_REQUEST = {
  value: 'createAgentRequest',
  label: `Créer une demande`
}
export const ACCOUNT_RIGHT_LIST_REQUESTS = {
  value: 'listAgentRequests',
  label: `Lister les demandes`
}
export const ACCOUNT_RIGHT_EDIT_REQUEST = {
  value: 'editAgentRequest',
  label: `Éditer une demande`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_REQUESTS
  ]
}
export const ACCOUNT_RIGHT_DELETE_REQUEST = {
  value: 'deleteAgentRequest',
  label: `Supprimer une demande`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_REQUESTS
  ]
}
export const ACCOUNT_RIGHT_SEND_REQUEST = {
  value: 'sendAgentRequest',
  label: `Envoyer une demande par email`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_REQUESTS
  ]
}

export const ACCOUNT_RIGHT_CREATE_UNAVAILABILITY = {
  value: 'createUnavailability',
  label: `Créer une indisponibilité`
}
export const ACCOUNT_RIGHT_LIST_UNAVAILABILITIES = {
  value: 'listUnavailabilities',
  label: `Lister les indisponibilités`
}
export const ACCOUNT_RIGHT_EDIT_UNAVAILABILITY = {
  value: 'editUnavailability',
  label: `Éditer une indisponibilité`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_UNAVAILABILITIES
  ]
}
export const ACCOUNT_RIGHT_DELETE_UNAVAILABILITY = {
  value: 'deleteUnavailability',
  label: `Supprimer une indisponibilité`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_UNAVAILABILITIES
  ]
}

export const ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS = {
  value: 'listInterventionReports',
  label: `Lister les reports d'interventions`
}
export const ACCOUNT_RIGHT_CREATE_INTERVENTION_REPORT = {
  value: 'createInterventionReport',
  label: `Créer un rapport d'intervention`
}
export const ACCOUNT_RIGHT_EDIT_INTERVENTION_REPORT = {
  value: 'editInterventionReport',
  label: `Éditer un rapport d'intervention`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS
  ]
}
export const ACCOUNT_RIGHT_SEND_INTERVENTION_REPORT = {
  value: 'sendInterventionReport',
  label: `Envoyer un rapport d'intervention`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS
  ]
}
export const ACCOUNT_RIGHT_DELETE_INTERVENTION_REPORT = {
  value: 'deleteInterventionReport',
  label: `Supprimer un rapport d'intervention`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS,
    ACCOUNT_RIGHT_EDIT_INTERVENTION_REPORT
  ]
}

export const ACCOUNT_RIGHT_READ_SHARED_DOCUMENTS = {
  value: 'readSharedDocuments',
  label: `Lire les documents partagés`
}

export const ACCOUNT_RIGHT_READ_EMAIL_TRACKING = {
  value: 'readEmailsTracking',
  label: `Accès au "Suivi des emails"`
}

export const ACCOUNT_RIGHT_READ_DASHBOARD = {
  value: 'readDashboard',
  label: `Accès au tableau de bord`
}

export const ACCOUNT_RIGHT_READ_SUPERVISION_TRACKING = {
  value: 'readSupervisionTracking',
  label: 'Accès à "Supervision"',
  dependencies: [
    ACCOUNT_RIGHT_LIST_MISSION_EVENTS
  ]
}

export const ACCOUNT_RIGHT_LIST_AGENT_HOURS = {
  value: 'listAgentHours',
  label: 'Accès à "Mes heures supplémentaires"'
}

export const ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_AGENT_TEMPLATE = {
  value: 'createAgencyContractAgentTemplate',
  label: `Créer un template de contrat agent`
}
export const ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE = {
  value: 'listAgencyContractAgentTemplates',
  label: `Lister les templates de contrat agent`
}
export const ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT_TEMPLATE = {
  value: 'editAgencyContractAgentTemplate',
  label: `Modifier un template de contrat agent`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE
  ]
}
export const ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT_TEMPLATE = {
  value: 'deleteAgencyContractAgentTemplate',
  label: `Supprimer un template de contrat agent`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE
  ]
}

export const ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_AGENT = {
  value: 'createAgencyContractAgent',
  label: `Créer un template de contrat agent`
}
export const ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT = {
  value: 'listAgencyContractAgents',
  label: `Lister les templates de contrat agent`
}
export const ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT = {
  value: 'editAgencyContractAgent',
  label: `Modifier un template de contrat agent`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT
  ]
}
export const ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT = {
  value: 'deleteAgencyContractAgent',
  label: `Supprimer un template de contrat agent`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT
  ]
}

export const ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_CUSTOMER_TEMPLATE = {
  value: 'createAgencyContractCustomerTemplate',
  label: `Créer un template client`
}
export const ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE = {
  value: 'listAgencyContractCustomerTemplates',
  label: `Lister les contrats client`
}
export const ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER_TEMPLATE = {
  value: 'editAgencyContractCustomerTemplate',
  label: `Modifier un contrat client`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE
  ]
}
export const ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER_TEMPLATE = {
  value: 'deleteAgencyContractCustomerTemplate',
  label: `Supprimer un contrat client`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE
  ]
}

export const ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_CUSTOMER = {
  value: 'createAgencyContractCustomer',
  label: `Créer un contrat client`
}
export const ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER = {
  value: 'listAgencyContractCustomers',
  label: `Lister les contrats client`
}
export const ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER = {
  value: 'editAgencyContractCustomer',
  label: `Modifier un contrat client`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER
  ]
}
export const ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER = {
  value: 'deleteAgencyContractCustomer',
  label: `Supprimer un contrat client`,
  dependencies: [
    ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER
  ]
}

export const ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_CUSTOMER = {
  value: 'createAgencyContractCustomerSignature',
  label: `Demander la signature électronique d'un contrat client`
}

export const ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_AGENT = {
  value: 'createAgencyContractAgentSignature',
  label: `Demander la signature électronique d'un contrat agent`
}

export const ACCOUNT_RIGHTS_GROUPS = [
  // {
  //   title: 'Gestion des droits utilisateur',
  //   options: [
  //     ACCOUNT_RIGHT_EDIT_USER_RIGHTS
  //   ]
  // },
  {
    title: 'Gestion des agents',
    options: [
      ACCOUNT_RIGHT_CREATE_AGENT,
      ACCOUNT_RIGHT_EDIT_AGENT,
      ACCOUNT_RIGHT_READ_AGENT,
      ACCOUNT_RIGHT_DELETE_AGENT,
      ACCOUNT_RIGHT_LIST_AGENTS,
      ACCOUNT_RIGHT_LIST_AVAILABLE_AGENTS
    ]
  },
  {
    title: 'Gestion des indisponibilités',
    options: [
      ACCOUNT_RIGHT_CREATE_UNAVAILABILITY,
      ACCOUNT_RIGHT_EDIT_UNAVAILABILITY,
      ACCOUNT_RIGHT_DELETE_UNAVAILABILITY,
      ACCOUNT_RIGHT_LIST_UNAVAILABILITIES
    ]
  },
  {
    title: 'Gestion des clients',
    options: [
      ACCOUNT_RIGHT_CREATE_CUSTOMER,
      ACCOUNT_RIGHT_EDIT_CUSTOMER,
      ACCOUNT_RIGHT_READ_CUSTOMER,
      ACCOUNT_RIGHT_DELETE_CUSTOMER,
      ACCOUNT_RIGHT_LIST_CUSTOMERS
    ]
  },
  {
    title: 'Gestion des sites',
    options: [
      ACCOUNT_RIGHT_CREATE_SITE,
      ACCOUNT_RIGHT_EDIT_SITE,
      ACCOUNT_RIGHT_READ_SITE,
      ACCOUNT_RIGHT_DELETE_SITE,
      ACCOUNT_RIGHT_LIST_SITES,
      ACCOUNT_RIGHT_LIST_SITE_ITEMS,
      ACCOUNT_RIGHT_EDIT_SITE_ITEMS
    ]
  },
  {
    title: 'Gestion des rondes',
    options: [
      ACCOUNT_RIGHT_CREATE_ROUND,
      ACCOUNT_RIGHT_EDIT_ROUND,
      ACCOUNT_RIGHT_READ_ROUND,
      ACCOUNT_RIGHT_DELETE_ROUND,
      ACCOUNT_RIGHT_LIST_ROUNDS,
      ACCOUNT_RIGHT_LIST_MISSIONS_ROUNDS
      // ,      ACCOUNT_RIGHT_LIST_ALL_ROUNDS
    ]
  },
  {
    title: 'Gestion des points de contrôle',
    options: [
      ACCOUNT_RIGHT_CREATE_CHECKPOINT,
      ACCOUNT_RIGHT_EDIT_CHECKPOINT,
      ACCOUNT_RIGHT_READ_CHECKPOINT,
      ACCOUNT_RIGHT_DELETE_CHECKPOINT,
      ACCOUNT_RIGHT_LIST_CHECKPOINTS
      // ,      ACCOUNT_RIGHT_LIST_ALL_CHECKPOINTS
    ]
  },
  {
    title: 'Gestion des services',
    options: [
      ACCOUNT_RIGHT_CREATE_MISSION,
      ACCOUNT_RIGHT_EDIT_MISSION,
      ACCOUNT_RIGHT_READ_MISSION,
      ACCOUNT_RIGHT_DELETE_MISSION,
      ACCOUNT_RIGHT_LIST_MISSIONS
      // ,  ACCOUNT_RIGHT_LIST_ALL_MISSIONS,
      // ACCOUNT_RIGHT_CREATE_MISSION_REQUEST,
      // ACCOUNT_RIGHT_LIST_MISSION_REQUESTS
    ]
  },
  // {
  //   title: 'Gestion des rapports de mission',
  //   options: [
  //     ACCOUNT_RIGHT_EDIT_REPORT,
  //     ACCOUNT_RIGHT_READ_REPORT,
  //     // ACCOUNT_RIGHT_HIDE_REPORT_EVENT, TODO
  //     ACCOUNT_RIGHT_LIST_REPORTS
  //   ]
  // },
  {
    title: 'Gestion des évènements de main courante',
    options: [
      ACCOUNT_RIGHT_CREATE_MISSION_EVENT,
      ACCOUNT_RIGHT_EDIT_MISSION_EVENT,
      ACCOUNT_RIGHT_DELETE_MISSION_EVENT,
      ACCOUNT_RIGHT_LIST_MISSION_EVENTS,
      ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS,
      ACCOUNT_RIGHT_READ_SITE_MISSION_EVENTS
    ]
  },
  {
    title: `Gestion des rapports d'interventions`,
    options: [
      ACCOUNT_RIGHT_CREATE_INTERVENTION_REPORT,
      ACCOUNT_RIGHT_EDIT_INTERVENTION_REPORT,
      ACCOUNT_RIGHT_DELETE_INTERVENTION_REPORT,
      ACCOUNT_RIGHT_SEND_INTERVENTION_REPORT,
      ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS
    ]
  },
  {
    title: 'Gestion des devis',
    options: [
      ACCOUNT_RIGHT_CREATE_ESTIMATE,
      ACCOUNT_RIGHT_EDIT_ESTIMATE,
      ACCOUNT_RIGHT_READ_ESTIMATE,
      ACCOUNT_RIGHT_SEND_ESTIMATE,
      ACCOUNT_RIGHT_DELETE_ESTIMATE,
      ACCOUNT_RIGHT_LIST_ESTIMATES
    ]
  },
  {
    title: 'Gestion des factures',
    options: [
      ACCOUNT_RIGHT_CREATE_INVOICE,
      ACCOUNT_RIGHT_EDIT_INVOICE,
      ACCOUNT_RIGHT_READ_INVOICE,
      ACCOUNT_RIGHT_SEND_INVOICE,
      ACCOUNT_RIGHT_DELETE_INVOICE,
      ACCOUNT_RIGHT_LIST_INVOICES
    ]
  },
  {
    title: 'Gestion des demandes',
    options: [
      ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
      ACCOUNT_RIGHT_CREATE_REQUEST,
      ACCOUNT_RIGHT_EDIT_REQUEST,
      ACCOUNT_RIGHT_LIST_REQUESTS,
      ACCOUNT_RIGHT_DELETE_REQUEST,
      ACCOUNT_RIGHT_SEND_REQUEST
    ]
  },
  // {
  //   title: 'Gestion des abonnements',
  //   options: [
  //     ACCOUNT_RIGHT_SUBSCRIBE,
  //     ACCOUNT_RIGHT_UNSUBSCRIBE,
  //     ACCOUNT_RIGHT_ADD_CREDIT_CARD,
  //     ACCOUNT_RIGHT_DELETE_CREDIT_CARD,
  //     ACCOUNT_RIGHT_LIST_CREDIT_CARDS,
  //     ACCOUNT_RIGHT_LIST_SUBSCRIPTIONS,
  //     ACCOUNT_RIGHT_LIST_SUBSCRIPTION_INVOICES
  //   ]
  // },
  // {
  //   title: 'Gestion des conversations',
  //   options: [
  //     ACCOUNT_RIGHT_MANAGE_CONVERSATIONS
  //   ]
  // },
  {
    title: `Gestion de l'agence`,
    options: [
      // ACCOUNT_RIGHT_READ_AGENCY_PLANNING,
      ACCOUNT_RIGHT_READ_SITES_PLANNING,
      ACCOUNT_RIGHT_READ_AGENTS_PLANNING,
      ACCOUNT_RIGHT_READ_DASHBOARD,
      ACCOUNT_RIGHT_READ_SUPERVISION_TRACKING,
      ACCOUNT_RIGHT_READ_EMAIL_TRACKING,
      ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS
      // ACCOUNT_RIGHT_READ_CUSTOMERS_PLANNING,
      // , ACCOUNT_RIGHT_READ_MISSIONS_PLANNING
    ]
  },
  {
    title: `Gestion des templates de contrat`,
    options: [
      ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_AGENT_TEMPLATE,
      ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE,
      ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT_TEMPLATE,
      ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT_TEMPLATE,
      ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_CUSTOMER_TEMPLATE,
      ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE,
      ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER_TEMPLATE,
      ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER_TEMPLATE
    ]
  },
  {
    title: `Gestion des contrat des agents`,
    options: [
      ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_AGENT,
      ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT,
      ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT,
      ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT,
      ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_AGENT
    ]
  },
  {
    title: `Gestion des contrat des clients`,
    options: [
      ACCOUNT_RIGHT_CREATE_AGENCY_CONTRACT_CUSTOMER,
      ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER,
      ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER,
      ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER,
      ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_CUSTOMER
    ]
  },
  {
    title: `Divers`,
    options: [
      ACCOUNT_RIGHT_LIST_AGENT_HOURS
    ]
  }
  //, {
  //   title: 'Extra',
  //   options: [
  //     ACCOUNT_RIGHT_DISPLAY_IMPORT,
  //     ACCOUNT_RIGHT_DISPLAY_STORE,
  //     ACCOUNT_RIGHT_DISPLAY_ASSISTANCE
  //   ]
  // }
]

export const ACCOUNT_RIGHTS = _.concat(...ACCOUNT_RIGHTS_GROUPS.map((r) => r.options))
export const ACCOUNT_INDEXED_RIGHTS = _.keyBy(ACCOUNT_RIGHTS, 'value')

// Droits par défaut des agents : Si mise à jour vérifier les dépendances !
export const ACCOUNT_AGENT_DEFAULT_RIGHTS = {
  [ACCOUNT_RIGHT_CREATE_MISSION.value]: true,
  [ACCOUNT_RIGHT_LIST_SITES.value]: true,
  [ACCOUNT_RIGHT_CREATE_SITE.value]: true,
  [ACCOUNT_RIGHT_LIST_CUSTOMERS.value]: true,
  [ACCOUNT_RIGHT_CREATE_SELF_REQUEST.value]: true,
  [ACCOUNT_RIGHT_CREATE_CUSTOMER.value]: true
}

export const ACCOUNT_MANAGER_DEFAULT_RIGHTS = _.mapValues(ACCOUNT_INDEXED_RIGHTS, _.stubTrue)
